import script from "./AppPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPagination.vue?vue&type=script&setup=true&lang=js"

import "./AppPagination.vue?vue&type=style&index=0&id=0eb5c1e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb5c1e8"]])

export default __exports__